export const formatToBRL = (value: number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}

export const formatToUF = (value: number) => {
  return (
    'UF ' +
    new Intl.NumberFormat('es-CL', {
      style: 'decimal',
      minimumFractionDigits: 2,
    }).format(value)
  )
}
